import type { Stripe } from '@stripe/stripe-js';
import { loadStripe } from '@stripe/stripe-js/pure';
import { env } from '../config/env';

/**
 * Stripe.js, loaded once and only when a page needs it (a pay page or the add-a-card dialog), never at app
 * start. The features that mount Stripe's own components are the only ones that know its React names.
 */
let stripePromise: Promise<Stripe | null> | null = null;

export function stripe(): Promise<Stripe | null> {
  stripePromise ??= loadStripe(env.stripePublishableKey);
  return stripePromise;
}

/** Whether this build can take card payments at all (no publishable key in PR environments). */
export const cardPaymentsAvailable = (): boolean => env.stripePublishableKey !== '';
export const isTestMode = (): boolean => env.stripePublishableKey.startsWith('pk_test_');
